import './OrderStepCircle.scss'

const OrderStepCircle = ({ number, text, active, onClick, disable }) => {
    const className = 'order-step-circle d-flex justify-content-center align-items-center'

    return (
        <>
            {!active ? (
                <div
                    className={`${className} rounded-circle text-formPrimary user-select-none`}
                    role={!disable ? 'button' : null}
                    onClick={!disable ? onClick : null}
                >
                    {number}
                </div>
            ) : (
                <div
                    className={`${className} w-auto px-3 rounded-pill bg-formPrimary text-basePrimary user-select-none`}
                >
                    <span className="text-magentaSecondary pe-2">{number}</span>
                    {text}
                </div>
            )}
        </>
    )
}

export default OrderStepCircle
